export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7340.80cc066e.jpg";